import * as validators from 'constructicon/lib/validators'

export default ({ fundraisingPage }) => {
  return {
    fields: {
      name: {
        label: 'Page Title',
        type: 'text',
        initial: fundraisingPage.name,
        maxLength: 255,
        validators: [validators.required('Please enter a page title')]
      },
      story: {
        label: 'Story',
        type: 'textarea',
        initial: fundraisingPage.story,
        placeholder: 'This copy will appear on your fundraising page.'
      },
      target: {
        label: 'Fundraising Target',
        type: 'number',
        initial: fundraisingPage.target ? parseInt(fundraisingPage.target) : undefined,
        validators: [
          validators.required('Please enter an amount'),
          validators.number('Must be a number'),
          val => parseInt(val) <= 0 && 'Please enter an amount greater than 0',
          val => parseInt(val) > 10000000 && 'Please enter an amount less than 10,000,000'
        ]
      }
    }
  }
}
